module.exports = __webpack_public_path__ + "static/img/no_label_icon.5daa2634.png";